export interface NoSpecialCharactersValidationErrorProps {
  regex: RegExp;
}
export class NoSpecialCharactersValidationError
  implements NoSpecialCharactersValidationErrorProps
{
  constructor(public regex: RegExp) {}
}
